import { useBreadcrumb } from '~/components/layout/Breadcrumb';
import { PageLoader } from '~/components/page/PageLoader';

export default function LimeInfoRoute() {
  useBreadcrumb('routes/lime-info', 'Lime Info');
  return <PageLoader pageName="lime-info" />;
}
